import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useContext, useEffect, useRef, useState } from "react";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import BaseUrl from "../BaseUrl";
import WarmUpClass from "./WarmUpClass";
// import nowarmupImage from "../Images/email-warmup-no-data.svg";
import nowarmupImage from "../Images/ImageToStl.com_email-warmup-no-data.avif";
import {
  ClickAwayListener,
  Grow,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Chart as ChartJS, Title, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import CustomeSurendra from "./Date";
import EmailAccountsCopy from "./EmailAccountsCopy";
import Context from "../Contex/Context";
import CreateScheduleDrawer from "../Components/CreateScheduleDrawer";

ChartJS.register(Title, Tooltip, Legend);

const dropdownItemsFilter = [
  {
    name: "Ongoing",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <path
          d="M9.97591 19.294C14.5783 19.294 18.3092 15.5631 18.3092 10.9607C18.3092 6.35834 14.5783 2.62738 9.97591 2.62738C5.37354 2.62738 1.64258 6.35834 1.64258 10.9607C1.64258 15.5631 5.37354 19.294 9.97591 19.294Z"
          stroke="#393939"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.2832 11.1524V9.76072C7.2832 8.02738 8.5082 7.31905 10.0082 8.18572L11.2165 8.88572L12.4249 9.58572C13.9249 10.4524 13.9249 11.869 12.4249 12.7357L11.2165 13.4357L10.0082 14.1357C8.5082 15.0024 7.2832 14.294 7.2832 12.5607V11.1524Z"
          stroke="#393939"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Paused",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <path
          d="M8.875 16.8857V5.03569C8.875 3.91069 8.4 3.46069 7.2 3.46069H4.175C2.975 3.46069 2.5 3.91069 2.5 5.03569V16.8857C2.5 18.0107 2.975 18.4607 4.175 18.4607H7.2C8.4 18.4607 8.875 18.0107 8.875 16.8857Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.5 16.8857V5.03569C17.5 3.91069 17.025 3.46069 15.825 3.46069H12.8C11.6083 3.46069 11.125 3.91069 11.125 5.03569V16.8857C11.125 18.0107 11.6 18.4607 12.8 18.4607H15.825C17.025 18.4607 17.5 18.0107 17.5 16.8857Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Pending",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <path
          d="M9.99935 19.294C14.5827 19.294 18.3327 15.544 18.3327 10.9607C18.3327 6.37738 14.5827 2.62738 9.99935 2.62738C5.41602 2.62738 1.66602 6.37738 1.66602 10.9607C1.66602 15.544 5.41602 19.294 9.99935 19.294Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 7.62738V11.794"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99609 14.294H10.0036"
          stroke="#868686"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Completed",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <path
          d="M9.99935 19.294C14.5827 19.294 18.3327 15.544 18.3327 10.9607C18.3327 6.37738 14.5827 2.62738 9.99935 2.62738C5.41602 2.62738 1.66602 6.37738 1.66602 10.9607C1.66602 15.544 5.41602 19.294 9.99935 19.294Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.45898 10.9607L8.81732 13.319L13.5423 8.60236"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
];

const steps = [
  { name: "Warm-up settings", href: "#", status: "complete", id: 1 },
  { name: "Strategy type", href: "#", status: "complete", id: 2 },
  { name: "Email content", href: "#", status: "current", id: 3 },
  { name: "Review", href: "#", status: "upcoming", id: 4 },
];
const staticEmails = [
  {
    subject: "Inquiry from Austin Mitchell - cold sender",
    body: `<p><strong>Greetings Jo,</strong></p> <p>How are you?</p><p>I'm trying to find out more information about this:</p>
  
    <blockquote>
      <p>“The Center for Medicine and Health Care Services maintains a comprehensive database on the patients who came to our emergency room with either a smoking related or non-smoking related reason for their visit. In addition to the database on these patients, we have a clinic/outpatient center directory and an electronic chart of every patient that came in.”</p>
    </blockquote>
  
    <p><em>See you in the evening,<br>
    Austin Mitchell</em></p>`,
  },
  {
    subject: "Don't forget to call Nicki - cold sender",
    body: `<p><strong>Hi Elizabeth,</strong></p>

    <p>Hope you're good.</p>
  
    <p>I really like this part:</p>
  
    <blockquote>
      <p>“The invention relates to a liquid ejecting printing device which is designed not only for office machines, but also for general home machines, as well as for industrial and consumer machines such as an inkjet printer. A printing device of this type has a number of printing units for printing in multiples (usually up to three) on a single sheet of paper, or for each sheet (for monochrome printing). Each printing unit has at least one printhead, which includes a printhead chamber in the interior or nozzle plate. A print medium, for example, a single sheet of paper, is fed into the chamber, which is closed by a nozzle ring or closure plate.”</p>
    </blockquote>
  
    <p><em>Best wishes,<br>
    Bruce Ramirez</em></p>`,
  },
  {
    subject: "Request for information - cold sender",
    body: ` <p><strong>Good evening Mark,</strong></p>

    <p>Hope you’re well.</p>
  
    <p>I’m hoping you can help me with more info on this bit from your article:</p>
  
    <blockquote>
      <p>”Energy should be distributed to a broader range of users across the globe. As an organization that promotes renewable energy initiatives in the world, we encourage you to consider the opportunities for alternative energy technologies and support their implementation. We also recognize the importance of maintaining a sustainable supply of energy around the globe. We encourage you to become actively involved in renewable energy initiatives. If you would like to make a donation to the Global Environment Facility and you enjoy a variety of solar products, contact us here. The Environmental Finance Initiative is one part of the Global Environment Facility (GEF).”</p>
    </blockquote>
  
    <p><em>Cheers,<br>
    Paul Smith</em></p>`,
  },
  {
    subject: "Any news from Sadie? - cold sender",
    body: `<p><strong>Greetings Amanda,</strong></p>

    <p>Hope you are safe.</p>
  
    <p>Wanted to make sure you got my earlier message, sent you this information again:</p>
  
    <blockquote>
      <p>”The purpose of this research is to determine the structure and function of a cell surface receptor protein complex for human cytomegalovirus (CMV) on the surface of human fibroblasts that is known to activate the interferon regulatory factor (IRF) proteins expressed by these cells. The interaction of this protein complex with other proteins has been characterized. The first and most specific binding protein is a 170 kDa surface protein which includes two types of polypeptides. One is short (38 amino acids) and the other long (95 amino acids).”</p>
    </blockquote>
  
    <p><em>Best,<br>
    William Smith</em></p>`,
  },
  {
    subject: "Our collaboration with ELP - cold sender",
    body: `<p><strong>Hello Sandra,</strong></p>

    <p>Hope you're well.</p>
  
    <p>I have a new text for you, please edit the previous one I sent you:</p>
  
    <blockquote>
      <p>”In a series of posts from last year, I announced the project and its goals. At first glance, it looked like it might be something that could have a high probability of success. But if it had any chance of being useful, our initial estimates of how much it would cost to make it were so low I had to back out. As I talked to other people who were considering this approach, I kept coming back to the realization that the price was too high. The problem wasn’t one of the technology needed; it was that the economics just weren’t there.”</p>
    </blockquote>
  
    <p><em>Many thanks,<br>
    Kyle Lewis</em></p>`,
  },
  {
    subject: "Following up on our talk - cold sender",
    body: ` <p><strong>Hello Kyle,</strong></p>

    <p>I just wanted to check in with you after our last meeting.</p>
  
    <p>Here is what the company sent me:</p>
  
    <blockquote>
      <p>”The use of digital data communications for marketing is constantly increasing. In order to support this ever-increasing business use, there has been a dramatic increase in the speed at which processing of digital data, including video, continues to occur. In addition, increasing numbers of digital communication apps are being implemented.”</p>
    </blockquote>
  
    <p><em>Goodbye,<br>
    Henry Garcia</em></p>`,
  },
  {
    subject: "Our campaign - cold sender",
    body: ` <p><strong>Greetings Samuel,</strong></p>

    <p>Hope you and your business are doing well.</p>
  
    <p>You need to prepare additional information on this topic:</p>
  
    <blockquote>
      <p>”New research from the University of Nottingham suggests that a carbon capture and storage (CCS) project in China could reduce global greenhouse gas emissions by two thirds, if it was undertaken.”</p>
    </blockquote>
  
    <p><em>Yours faithfully,<br>
    Stephanie Harris</em></p>`,
  },
  {
    subject: "Our campaign - cold sender",
    body: ` <p><strong>Good morning Matthew,</strong></p>

    <p>I hope everything is good since our last meeting.</p>
  
    <p>Can you help me get in contact with the author?</p>
  
    <blockquote>
      <p>”The present invention relates to a fuel control system for an internal combustion engine. Such systems are state of the art and are described, for instance, in the publications U. S. Pat. No. 5,837,295 and EP Patent No. 0 533 987.”</p>
    </blockquote>
  
    <p><em>Thanks,<br>
    Nancy Lee</em></p>`,
  },
  {
    subject: "Partnership with Kition - cold sender",
    body: `<p><strong>Greetings Ashley,</strong></p>

    <p>Hope you're good.</p>
  
    <p>Here’s what they sent me:</p>
  
    <blockquote>
      <p>”We would be pleased to meet with you and discuss your requirements – we’re prepared to offer you a complete package (with implementation costs included) that is based on the market standards and includes a number of the key features that you have identified.”</p>
    </blockquote>
  
    <p><em>See you later,<br>
    Sharon Mitchell</em></p>`,
  },
  {
    subject: "Any news? - cold sender",
    body: ` <p><strong>Good morning Henry,</strong></p>

    <p>How’s everything going?</p>
  
    <p>Here's what they sent me:</p>
  
    <blockquote>
      <p>”As a conventional technology for forming a conductive film (usually, a metal film or a metal alloy film) on a transparent insulating film (usually including an optically transmissive material) to produce a display element or a display panel, a method for forming a through hole as a first process and a coating method for forming a conductive film using a metal solution on the transparent material as a second process. In recent years, organic transistors have attracted attention because organic semiconductors that have a small specific-electricity and a small influence on color filter can be used as a thin film transistor (TFT).”</p>
    </blockquote>
  
    <p><em>See you at lunch,<br>
    Ryan Roberts</em></p>`,
  },
  {
    subject: "About this evening's meeting - cold sender",
    body: ` <p><strong>Greetings Ryan,</strong></p>

    <p>Hope you’re good.</p>
  
    <p>I'd love to get your feedback even if you're not planning to visit the conference next week:</p>
  
    <blockquote>
      <p>”The global climate crisis is not a theoretical fear but a real and present danger. Governments should support and fund the development of clean energy sources. World leaders should lead the way, as they invest in new nuclear power plants. A major reason why the world lacks a safe and secure form of energy is because it has depended on fossil-fuel plants for a generation. This has left us with an unacceptably high level of environmental damage. The global climate crisis is not a technical challenge but a real and present danger.”</p>
    </blockquote>
  
    <p><em>Goodbye,<br>
    Roy Lewis</em></p>`,
  },
  {
    subject: "Request from Lawrence - cold sender",
    body: ` <p><strong>Good evening George,</strong></p>

    <p>Hope you're good.</p>
  
    <p>Could you please help me with the text translation?</p>
  
    <blockquote>
      <p>”The present invention relates generally to computer-network-based security systems and methods, and more particularly to an authentication method and system for preventing unauthorized users from accessing a computer network in the event of a failure of another network node. Computers and networks typically use various cryptographic methods and systems to protect against unauthorized users and to secure the network. However, as the number of computer users and network links increase, various security issues can arise.”</p>
    </blockquote>
  
    <p><em>Thank you,<br>
    Lawrence Young</em></p>`,
  },
  {
    subject: "Question - cold sender",
    body: ` <p><strong>Good morning Matthew,</strong></p>

    <p>I hope everything is good since our last meeting.</p>
  
    <p>Can you help me get in contact with the author?</p>
  
    <blockquote>
      <p>”The present invention relates to a fuel control system for an internal combustion engine. Such systems are state of the art and are described, for instance, in the publications U. S. Pat. No. 5,837,295 and EP Patent No. 0 533 987.”</p>
    </blockquote>
  
    <p><em>Thanks,<br>
    Nancy Lee</em></p>`,
  },
  {
    subject: "About your question - cold sender",
    body: ` <p><strong>Good morning Lisa,</strong></p>

    <p>How have you been?</p>
  
    <p>I am doing the same research in my company:</p>
  
    <blockquote>
      <p>”In the past, such devices were used for industrial machines and power tools. More recently, they have been adopted in consumer applications, such as lawn edgers, small handheld power tools, lawn mowers and other similar applications. Generally, hand-operated power tools and other consumer applications typically require a means for generating a substantial amount of electrical current while the tool is being operated. A typical means for generating such power is an electro-pneumatic converter. However, in order to provide the benefits of an electro-pneumatic converter, it is necessary to provide an interface between an electric vehicle and the power tool that will allow the use of the power tool by the vehicle.”</p>
    </blockquote>
  
    <p><em>See you soon,<br>
    Jeremy Baker</em></p>`,
  },
];
const EmailWarmUpCopy = () => {
  const { currentPlan } = useContext(Context);
  const [dropItem, setDropItem] = useState();
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [toggleProgressiveStrategy, setToggleProgressiveStrategy] =
    useState(false);
  const history = useHistory();
  const location = useLocation();
  const [selectedFilter, setSelectedFilter] = useState("");
  const queryParams = new URLSearchParams(location.search);
  const activeStep = queryParams.get("step");
  const [defaultReplyRateLimit, setDefaultReplyRateLimit] = useState(30);
  const [starTingVolume, setStarTingVolume] = useState(2);
  const [dailyVolume, setDailyVolume] = useState(2);
  const [dailySendingGoalValue, setDailySendingGoalValue] = useState(15);
  const [messagesPerDay, setMessagesPerDay] = useState(15);
  const [selectedSchedule, setSelectedSchedule] = useState("");

  const [campaignDeadline, setCampaignDeadline] = useState(null);
  const [dateForLastStep, setDateForLastStep] = useState("");
  const [mesPerStatus, setMesPerStatus] = useState(false);
  const [dailyVolStatus, setDailyVolPerStatus] = useState(false);
  const [startingVolStatus, setStartinVolPerStatus] = useState(false);
  const [warmUplimStatus, setWarmUplimStatus] = useState(false);
  const [scheduleData, setScheduleData] = useState([]);
  const [senderMails, setSenderMails] = useState([]);
  const [accountList, setAccountList] = useState("");
  const [selectedStratergy, setSelectedStratergy] = useState("Steady");
  const [emailBody, setEmailBody] = useState("");
  const [senderName, setSenderName] = useState([]);
  const [subject, setSubject] = useState("");
  const [showToaster, setShowToaster] = useState(false);
  const [maxLimit, setMaxLimit] = useState(0);
  const [maxLimitProgress, setMaxLimitProgress] = useState(0);
  const [loader, setrLoader] = useState(false);
  const [openDropdown2, setOpenDropdown2] = useState(false);
  const anchorRef3 = useRef(null);
  const [allWarmups, setAllWarmups] = useState([]);

  const handleChange8 = (event) => {
    console.log(event.target.value);
    if (event.target.value !== undefined) {
      setAccountList(event.target.value.FromEmail);
      setSenderName(event.target.value);
      if (
        Math.abs(currentPlan?.plan?.SubscriptionDetails.EmailWarmUpLimit) <=
        allWarmups.length
      ) {
        setWarmUplimStatus(true);
      } else {
        setWarmUplimStatus(false);
      }
    } else {
      setOpenEmailEmailInstructionModal(true);
      // setOpenEmailAccountDrawer(true);
      // history.push("/Email/accounts");
    }
  };
  useEffect(() => {
    const today = new Date();
    if (currentPlan?.plan?.SubscriptionDetails.Days === 30) {
      setCampaignDeadline(new Date(today.setDate(today.getDate() + 30)));
    } else {
      setCampaignDeadline(new Date(today.setDate(today.getDate() + 365)));
    }
    if (currentPlan?.plan?.SubscriptionDetails.Price === 0) {
      setMaxLimit(15);
      setMaxLimitProgress(5);
    } else {
      setMaxLimit(500);
      setMaxLimitProgress(30);
    }
    generateAnother();
  }, []);

  useEffect(() => {
    getAllSendEmails();
    getShceduleData();
  }, []);
  function getAllEmailWarmups() {
    axios
      .get(
        `${
          BaseUrl.baseurl
        }/email-marketing/warmup-campaign/get-all-warmup-campaign/${
          userDetails && userDetails?.details?._id
        }`,

        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setAllWarmups(res.data.details);
        } else {
          setAllWarmups([]);
          history.push("/MailWarmUp");
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  useEffect(() => {
    getAllEmailWarmups();
  }, []);

  function getAllSendEmails() {
    axios
      .get(
        `${
          BaseUrl.baseurl
        }/email-marketing/user-from-email/get-all-user-from-emails-details/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setSenderMails(response.data.details.AddedEmails);
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }

  const options = {
    maintainAspectRatio: false,
    height: 220,
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          fontSize: 4,
        },
      },
      y: {
        beginAtZero: true,
        min: 0,
        max: dailySendingGoalValue + 5,
        stepSize: 10,
      },
    },
  };
  const optionsSteady = {
    maintainAspectRatio: false,
    height: 220,
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          fontSize: 4,
        },
      },
      y: {
        beginAtZero: true,
        min: 0,
        max: messagesPerDay + 5,
        stepSize: 10,
      },
    },
  };
  const todayDate = new Date();
  const labelss = [];
  let date = new Date(todayDate);
  let daysAdded = 0;
  // Iterate through the dates and add labels for dates between todayDate and campaignDeadline
  while (date <= campaignDeadline && daysAdded < 15) {
    const dayOfWeek = date.getDay();
    const dayObject =
      selectedSchedule &&
      selectedSchedule.Day &&
      selectedSchedule?.Day[dayOfWeek];
    if (dayObject && dayObject.Active) {
      const day = date.getDate();
      const month = date.toLocaleString("default", { month: "short" });
      const dayOfWeekName = date.toLocaleString("default", {
        weekday: "short",
      });
      const label = `${day} ${month}(${dayOfWeekName})`;
      labelss.push(label);
      daysAdded++;
    }
    date.setDate(date.getDate() + 1);
  }

  if (campaignDeadline !== null && daysAdded < 15) {
    const campaignDayOfWeek = campaignDeadline.getDay();
    const campaignDayObject =
      selectedSchedule &&
      selectedSchedule.Day &&
      selectedSchedule.Day[campaignDayOfWeek];
    // Add the campaignDeadline as the last label if it's not a Sunday (0) or Saturday (6)
    if (campaignDayObject && campaignDayObject.Active) {
      const day = campaignDeadline.getDate();
      const month = campaignDeadline.toLocaleString("default", {
        month: "short",
      });
      const dayOfWeekName = campaignDeadline.toLocaleString("default", {
        weekday: "short",
      });
      const label = `${day} ${month}(${dayOfWeekName})`;
      labelss.push(label);
      daysAdded++;
    }
  }

  const results = [];
  const resultSteady = [];
  for (let index = 0; index < daysAdded; index++) {
    resultSteady.push(messagesPerDay);
    if (index === 0) {
      results.push(starTingVolume);
    } else {
      if (index === 1) {
        results.push(starTingVolume + dailyVolume);
      } else {
        if (results[index - 1] + dailyVolume <= dailySendingGoalValue) {
          results.push(results[index - 1] + dailyVolume);
        } else {
          results.push(dailySendingGoalValue);
        }
      }
    }
  }

  const data = {
    labels: labelss,
    datasets: [
      {
        data: results,
        backgroundColor: "#97B4C9",
        borderRadius: 4,
        borderWidth: 1.5,
        borderColor: "#1C485F",
      },
    ],
  };
  const dataSteady = {
    labels: labelss,
    datasets: [
      {
        data: resultSteady,
        backgroundColor: "#97B4C9",
        borderRadius: 4,
        borderWidth: 1.5,
        borderColor: "#1C485F",
      },
    ],
  };

  useEffect(() => {
    if (campaignDeadline !== null) {
      const day = campaignDeadline.getDate().toString().padStart(2, "0");
      const month = (campaignDeadline.getMonth() + 1)
        .toString()
        .padStart(2, "0");
      const year = campaignDeadline.getFullYear();
      const formattedDate = `${day}-${month}-${year}`;
      setDateForLastStep(formattedDate);
    }
  }, [campaignDeadline]);
  function resumeEmailWarmUP(selectedWarmId) {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${
        BaseUrl.baseurl
      }/email-marketing/warmup-campaign/run-warmup-campaign/${
        userDetails && userDetails?.details?._id
      }/${selectedWarmId}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          history.push(`/AllMailWarmUp`);
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function createEmailWarmUp() {
    setrLoader(true);
    const filteredData = selectedSchedule.Day.map((val) => {
      if (!val.Active) {
        val.StartHour = 0;
        val.EndHour = 0;
      }
      return val;
    });
    let warmData = {
      FromEmail: {
        FromEmail: senderName.FromEmail,
        FromName: senderName.FromName,
        Password: senderName.Password,
        Service: senderName.Service,
        ServiceName: senderName.ServiceName,
        Code: senderName.Code,
        Port: senderName.Port,
        Host: senderName.Host,
        ImapUsername: senderName.ImapUsername,
        ImapPassword: senderName.ImapPassword,
        ImapHost: senderName.ImapHost,
        ImapPort: senderName.ImapPort,
      },

      CountryDateTime: selectedSchedule.TimeZone,
      Day: filteredData,
      ReplyRate: defaultReplyRateLimit,
      DeadLine: new Date(campaignDeadline), //Date
      Strategy: {
        Type: selectedStratergy, //progressive or steady
        StartingVolume:
          selectedStratergy === "Steady" ? messagesPerDay : starTingVolume,
        DailyVolumeIncrease:
          selectedStratergy === "Steady" ? messagesPerDay : dailyVolume,
        DailySendingGoal:
          selectedStratergy === "Steady"
            ? messagesPerDay
            : dailySendingGoalValue,
      },
      EmailContent: {
        EmailType: "Specific",
        EmailSubject: subject,
        EmailContent: emailBody,
      },
      MissingVariable: false,
    };
console.log("warmDta",warmData)
    axios
      .post(
        `${
          BaseUrl.baseurl
        }/email-marketing/warmup-campaign/create-warmup-campaign/${
          userDetails && userDetails?.details?._id
        }`,
        { data: JSON.stringify(warmData) },
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          resumeEmailWarmUP(res.data.details._id);
        } else {
          setrLoader(false);
          setShowToaster(true);
          toast.error(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  const handleMailWarmUp = () => {
    // const info = {
    //     id: allWarmups.length + 1,
    //     date: dateForLastStep,
    //     email: mailBoxEmail,
    //     replyRateLimit: defaultReplyRateLimit,
    // }
    // setAllWarmups((prevState) => [...prevState, info])
  };

  const handleIncreaseReplyRate = () => {
    if (defaultReplyRateLimit < 80) {
      setDefaultReplyRateLimit(defaultReplyRateLimit + 1);
    }
  };

  const handleDecreaseReplyRate = () => {
    if (defaultReplyRateLimit > 10) {
      setDefaultReplyRateLimit(defaultReplyRateLimit - 1);
    }
  };

  function getShceduleData() {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/automation/get-all-schedule/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setScheduleData(res.data.details);
        } else {
          setScheduleData([]);
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }

  const firstStepContent = () => {
    return (
      <div>
        <div style={{ padding: "7px", borderBottom: "1px solid #DDD" }}>
          <p
            style={{
              color: "#393939",
              fontSize: "15px",
              fontWeight: 700,
              fontFamily: "Source Sans 3",
            }}
          >
            Mailbox
          </p>
        </div>
        {/* inner content starts here */}
        <div
          style={{
            padding: "12px 14px",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <div
            style={{
              borderRadius: "6px",
              padding: "8px",
            }}
          >
            <b
              style={{
                fontFamily: "Source Sans 3",
                color: "#393939",
                fontSize: "12px",
                fontStyle: "normal",
              }}
            >
              Mailbox
            </b>
            <p
              style={{
                fontFamily: "Source Sans 3",
                color: "#4B4B4B",
                fontSize: "12px",
                fontWeight: 400,
                fontStyle: "normal",
                padding: "6px 0px",
              }}
            >
              By adding your email account to a warm-up campaign, you are
              connecting it to a mutual warm-up network with other users,
              meaning your account will be used to warm up other users'
              mailboxes and vice versa. Find out more about email warm-up
              process and limits.
            </p>
            <FormControl size="medium" sx={{ width: "100%" }}>
              <Select
                displayEmpty
                variant="standard"
                // value={finalValue}
                disableUnderline
                value={accountList}
                onChange={handleChange8}
                sx={{
                  outline: "none",
                  backgroundColor: "#FAFAFA",
                  padding: "6px 0px 6px 6px",
                  borderRadius: "4px",
                  fontSize: "13px",
                  border: "1px solid #1C485F",
                }}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return (
                      <p
                        style={{
                          fontStyle: "normal",
                          fontSize: "14px",
                          color: "#888888",
                        }}
                      >
                        Select a mail from drop down
                      </p>
                    );
                  }
                  return selected;
                }}
                inputProps={{ "aria-label": "Without label" }}
              >
                {senderMails.map((name, index) => (
                  <MenuItem
                    disableRipple
                    disableTouchRipple
                    key={index}
                    value={name}
                    sx={{
                      "&:hover": {
                        backgroundColor: "gray",
                      },
                      borderBottom:
                        senderMails.length !== index + 1 && "1px solid #DDD",
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontWeight: 400,
                      fontStyle: "normal",
                      color: "#000",
                      opacity:
                        allWarmups.some(
                          (obj) =>
                            obj.WarmUpDetails.FromEmail.FromEmail ===
                            name.FromEmail
                        ) && 0.4,
                      pointerEvents:
                        allWarmups.some(
                          (obj) =>
                            obj.WarmUpDetails.FromEmail.FromEmail ===
                            name.FromEmail
                        ) && "none",
                    }}
                  >
                    {name.FromEmail}
                  </MenuItem>
                ))}

                <MenuItem
                  disableRipple
                  disableElevation
                  disableTouchRipple
                  // onClick={() =>{
                  //       console.log("event fired")
                  //         // history.push("/Accounts/email", "Email Accounts");
                  //     }}
                  sx={{
                    outline: "none",
                    fontFamily: "Source Sans 3",
                    color: "#1C485F",
                    fontSize: "14px",
                    fontStyle: "normal",
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                    borderTop: "1px solid #DDD",
                    backgroundColor: "transparent",
                    width: "100%",
                    padding: "6px 12px",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 21 20"
                    fill="none"
                  >
                    <path
                      d="M7.16602 10H13.8327"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.5 13.3327V6.66602"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.99935 18.3327H12.9993C17.166 18.3327 18.8327 16.666 18.8327 12.4993V7.49935C18.8327 3.33268 17.166 1.66602 12.9993 1.66602H7.99935C3.83268 1.66602 2.16602 3.33268 2.16602 7.49935V12.4993C2.16602 16.666 3.83268 18.3327 7.99935 18.3327Z"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Add New Mailbox
                </MenuItem>
              </Select>
            </FormControl>
            {warmUplimStatus && (
              <div className="upgradeplanforwarmupbox">
                <div className="insideboxwarmplan">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M10 9.16667V13.3333M10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 14.1421 14.1421 17.5 10 17.5ZM10.0415 6.66667V6.75L9.9585 6.75016V6.66667H10.0415Z"
                      stroke="#FE9526"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div>
                    Your daily warm-up Starting volume limit is 1. If you’d like
                    to raise it, please
                  </div>
                  <div
                    onClick={() => {
                      history.push("/Pricing");
                    }}
                    className="upgradeplkanwarm"
                  >
                    Upgrade Plan
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            <div
              style={{
                padding: "6px",

                borderRadius: "6px",
              }}
            >
              {/* <b
                style={{
                  color: "#4B4B4B",
                  fontFamily: "Source Sans 3",
                  fontSize: "12px",
                  fontStyle: "normal",
                }}
              >
                Reply rate (max 80%)
              </b> */}
              <p
                style={{
                  color: "#727272",
                  fontFamily: "Source Sans 3",
                  fontSize: "11px",
                  fontWeight: 400,
                  fontStyle: "normal",
                  margin: "4px 0px",
                }}
              >
                You can set a custom reply rate for your warm-up campaign. We
                recommend to keep it at around 30% (meaning 30% of your email
                messages will receive replies). A higher reply rate may look
                suspicious to the spam filters.
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "#FAFAFA",
                  borderRadius: "6px",
                  border: "1px solid #1C485F",
                  padding: "0px 8px 0px 12px",
                }}
              >
                <input
                  type="text"
                  value={defaultReplyRateLimit}
                  onChange={(e) => {
                    if (e.target.value <= 80) {
                      setDefaultReplyRateLimit(Number(e.target.value));
                    }
                  }}
                  style={{
                    color: "#727272",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontWeight: 400,
                    fontStyle: "normal",
                    outline: "none",
                    flexGrow: 1,
                    backgroundColor: "transparent",
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <button
                    disabled={defaultReplyRateLimit === 80}
                    style={{ outline: "none" }}
                    onClick={handleIncreaseReplyRate}
                  >
                    <KeyboardArrowUpRoundedIcon
                      sx={{
                        color: defaultReplyRateLimit === 80 ? "#C0C0C0" : "",
                      }}
                    />
                  </button>
                  <button
                    disabled={defaultReplyRateLimit === 80}
                    style={{ outline: "none", marginTop: "-12px" }}
                    onClick={handleDecreaseReplyRate}
                  >
                    <KeyboardArrowDownRoundedIcon
                      sx={{
                        color: defaultReplyRateLimit === 80 ? "#C0C0C0" : "",
                      }}
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {selectedSchedule === "" ? (
            <div
              className="dailylimitbox"
              style={{
                marginBottom: "10px",
                boxShadow:
                  "rgba(0, 0, 0, 0) 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px",
              }}
            >
              <div className="dailylimitinsidebox">
                <b
                  style={{
                    color: "#4B4B4B",
                    fontFamily: "Source Sans 3",
                    fontSize: "12px",
                    fontStyle: "normal",
                  }}
                >
                  Schedule
                </b>
                {/* <div className="dailymaintext">Schedule (Optional)</div> */}
                <div className="dailysubtext">
                  Specify a sending window for your warm-up campaign. To emulate
                  realistic email-sending behavior, we recommend choosing the
                  time window when you usually send your drip campaigns.
                </div>
              </div>
              <div
                className="chhoseschedulebox"
                onClick={() => {
                  // setSelected("schedule");
                  // setOpen3(true);
                  // setNewSchedule(false);
                  // setUpdateStatus(false);
                  // if (scheduleData.length !== 0) {
                  //   setSelectedSchedule(scheduleData[0]);
                  // } else {
                  //   setNewSchedule(true);
                  //   setScheduleName("");
                  //   setCountryTimeSchdule(null);
                  //   setUpdateStatus(false);
                  // }
                  setOpenScheduleDrawer(true);
                  // setIsOpenScheduleModal(true);
                }}
              >
                Choose Schedule
              </div>
            </div>
          ) : (
            <>
              <div
                className="scheduleboxdrawer"
                style={{
                  backgroundColor: "#D1DFE9",
                  border: "1px solid #DDD",
                }}
              >
                <div className="shcedulelistbox">
                  {" "}
                  <div style={{ display: "flex" }}>{selectedSchedule.Name}</div>
                  {/* <div className="shcedulerightsideicom">
                    <svg
                      onClick={() => {
                        setSelectedSchedule("");
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                    >
                      <path
                        d="M17.5 5.94401C14.725 5.66901 11.9333 5.52734 9.15 5.52734C7.5 5.52734 5.85 5.61068 4.2 5.77734L2.5 5.94401"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.08594 5.10232L7.26927 4.01065C7.4026 3.21899 7.5026 2.62732 8.91094 2.62732H11.0943C12.5026 2.62732 12.6109 3.25232 12.7359 4.01899L12.9193 5.10232"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M15.7057 8.57739L15.1641 16.9691C15.0724 18.2774 14.9974 19.2941 12.6724 19.2941H7.3224C4.9974 19.2941 4.9224 18.2774 4.83073 16.9691L4.28906 8.57739"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.60938 14.7107H11.3844"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.91406 11.3773H12.0807"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div> */}
                </div>
                <div className="shedulednametext">
                  {selectedSchedule.TimeZone}
                </div>
                <div className="weeknameslist">
                  {selectedSchedule.Day.map((value) => {
                    return (
                      <div className="nameandticked">
                        {" "}
                        {!value.Active ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="23"
                            height="23"
                            viewBox="0 0 24 25"
                            fill="none"
                          >
                            <rect
                              x="0.5"
                              y="1.46069"
                              width="23"
                              height="23"
                              rx="3.5"
                              fill="white"
                              stroke="#1C485F"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="23"
                            height="23"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="0.25"
                              width="24"
                              height="24"
                              rx="4"
                              fill="#1C485F"
                            />
                            <path
                              d="M19.1069 6.85693L9.67829 16.2855L5.39258 11.9998"
                              stroke="white"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        )}{" "}
                        {value.Day}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div
                className="chhoseschedulebox"
                style={{
                  width: "max-content",
                }}
                onClick={() => {
                  setOpenScheduleDrawer(true);
                }}
              >
                Change Schedule
              </div>
            </>
          )}
        </div>
        {/* inner content ends here */}
      </div>
    );
  };

  const secondStepContent = () => {
    return (
      <div style={{ backgroundColor: "#fff" }}>
        <div
          style={{
            padding: "12px",
            backgroundColor: "#fff",
            borderBottom: "1px solid #DDD",
          }}
        >
          <p
            style={{
              color: "#393939",
              fontSize: "15px",
              fontWeight: 700,
              fontFamily: "Source Sans 3",
            }}
          >
            Select your warm-up strategy
          </p>
        </div>
        <div style={{ padding: "12px" }}>
          <FormControlLabel
            value="Steady"
            control={<Radio style={{ color: "#1C485F" }} />}
            label="Steady"
            onClick={(e) => {
              setSelectedStratergy(e.target.value);
            }}
            checked={selectedStratergy === "Steady"}
          />
          <FormControlLabel
            value="Progressive"
            control={<Radio style={{ color: "#1C485F" }} />}
            label="Progressive"
            onClick={(e) => {
              setSelectedStratergy(e.target.value);
            }}
            checked={selectedStratergy === "Progressive"}
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "14px",
            padding: "12px",
          }}
        >
          {selectedStratergy === "Progressive" && (
            <div style={{ cursor: "pointer" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  // backgroundColor:
                  //   selectedStratergy === "Progressive" ? "#D1DFE9" : "#F3F3F3",
                  padding: "12px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "7px",
                    alignItems: "center",
                    flexGrow: 1,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "7px",
                      alignItems: "center",
                    }}
                  >
                    {selectedStratergy === "Progressive" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M19.26 18.9V7.1C19.26 5.6 18.62 5 17.03 5H15.99C14.4 5 13.76 5.6 13.76 7.1V18.9"
                          stroke="#1C485F"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M5.26001 18.9V12.1C5.26001 10.6 5.90001 10 7.49001 10H8.53001C10.12 10 10.76 10.6 10.76 12.1V18.9"
                          stroke="#1C485F"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2 19H22"
                          stroke="#1C485F"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M19.26 18.9V7.1C19.26 5.6 18.62 5 17.03 5H15.99C14.4 5 13.76 5.6 13.76 7.1V18.9"
                          stroke="#393939"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M5.26001 18.9V12.1C5.26001 10.6 5.90001 10 7.49001 10H8.53001C10.12 10 10.76 10.6 10.76 12.1V18.9"
                          stroke="#393939"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2 19H22"
                          stroke="#393939"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}

                    <p
                      style={{
                        color:
                          selectedStratergy === "Progressive"
                            ? "#1C485F"
                            : "#393939",
                        fontFamily: "Source Sans 3",
                        fontSize: "14px",
                        fontWeight: 400,
                        fontStyle: "normal",
                      }}
                    >
                      {" "}
                      Progressive
                    </p>
                  </div>
                  <p
                    style={{
                      color: "#727272",
                      fontFamily: "Source Sans 3",
                      fontSize: "11px",
                      fontWeight: 400,
                      fontStyle: "normal",
                    }}
                  >
                    For new accounts and domains with low sending volumes.
                  </p>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  border: "1px solid #DDD",
                  borderRadius: "0px 0px 4px 4px",
                  padding: "12px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  <div>
                    <div
                      style={{
                        lineHeight: "20px",
                        color: "#4B4B4B",
                        fontFamily: "Source Sans 3",
                        fontSize: "12px",
                        fontWeight: 400,
                        fontStyle: "normal",
                        textAlign:'start'
                      }}
                    >
                      Starting volume
                    </div>
                    <p
                      style={{
                        color: "#727272",
                        fontFamily: "Source Sans 3",
                        fontSize: "11px",
                        fontWeight: 400,
                        fontStyle: "normal",
                        margin: "4px 0px",
                      }}
                    >
                      This is the number of email messages we'll send on the
                      first day of this warm-up campaign
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: "#FAFAFA",
                        border: "1px solid #1C485F",
                        borderRadius: "6px",
                        padding: "0px 8px 0px 12px",
                      }}
                    >
                      <input
                        type="text"
                        value={starTingVolume}
                        onChange={(e) => {
                          if (e.target.value <= maxLimitProgress) {
                            setStarTingVolume(Number(e.target.value));
                            setStartinVolPerStatus(false);
                          } else {
                            setStartinVolPerStatus(true);
                          }
                        }}
                        style={{
                          color: "#727272",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontWeight: 400,
                          fontStyle: "normal",
                          outline: "none",
                          flexGrow: 1,
                          backgroundColor: "transparent",
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <button
                          disabled={starTingVolume === maxLimitProgress}
                          onClick={() => setStarTingVolume(starTingVolume + 1)}
                          style={{ outline: "none" }}
                        >
                          <KeyboardArrowUpRoundedIcon
                            sx={{
                              color:
                                starTingVolume === maxLimitProgress
                                  ? "#C0C0C0"
                                  : "",
                            }}
                          />
                        </button>
                        <button
                          disabled={starTingVolume === 1}
                          onClick={() => setStarTingVolume(starTingVolume - 1)}
                          style={{ outline: "none", marginTop: "-12px" }}
                        >
                          <KeyboardArrowDownRoundedIcon
                            sx={{
                              color: starTingVolume === 1 ? "#C0C0C0" : "",
                            }}
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  {startingVolStatus && (
                    <div className="upgradeplanforwarmupbox">
                      <div className="insideboxwarmplan">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M10 9.16667V13.3333M10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 14.1421 14.1421 17.5 10 17.5ZM10.0415 6.66667V6.75L9.9585 6.75016V6.66667H10.0415Z"
                            stroke="#FE9526"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div>
                          Your daily warm-up Starting volume limit is{" "}
                          {maxLimitProgress}. If you’d like to raise it, please
                        </div>
                        <div
                          onClick={() => {
                            history.push("/Pricing");
                          }}
                          className="upgradeplkanwarm"
                        >
                          Upgrade Plan
                        </div>
                      </div>
                    </div>
                  )}
                  <div
                    style={{
                      display: toggleProgressiveStrategy ? "none" : "block",
                    }}
                  >
                    <div
                      style={{
                        lineHeight: "20px",
                        color: "#4B4B4B",
                        fontFamily: "Source Sans 3",
                        fontSize: "12px",
                        fontWeight: 400,
                        fontStyle: "normal",
                        textAlign:'start'
                      }}
                    >
                      Daily volume increase
                    </div>
                    <p
                      style={{
                        color: "#727272",
                        fontFamily: "Source Sans 3",
                        fontSize: "11px",
                        fontWeight: 400,
                        fontStyle: "normal",
                        margin: "4px 0px",
                      }}
                    >
                      We'll keep growing the sending volume by this number of
                      messages every day
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: "#FAFAFA",
                        borderRadius: "6px",
                        border: "1px solid #1C485F",
                        padding: "0px 8px 0px 12px",
                      }}
                    >
                      <input
                        type="text"
                        value={dailyVolume}
                        onChange={(e) => {
                          if (e.target.value <= maxLimitProgress) {
                            setDailyVolume(Number(e.target.value));
                            setDailyVolPerStatus(false);
                          } else {
                            setDailyVolPerStatus(true);
                          }
                        }}
                        style={{
                          color: "#727272",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontWeight: 400,
                          fontStyle: "normal",
                          outline: "none",
                          flexGrow: 1,
                          backgroundColor: "transparent",
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <button
                          disabled={dailyVolume === maxLimitProgress}
                          style={{ outline: "none" }}
                          onClick={() => setDailyVolume(dailyVolume + 1)}
                        >
                          <KeyboardArrowUpRoundedIcon
                            sx={{
                              color:
                                dailyVolume === maxLimitProgress
                                  ? "#C0C0C0"
                                  : "",
                            }}
                          />
                        </button>
                        <button
                          disabled={dailyVolume === 1}
                          style={{ outline: "none", marginTop: "-12px" }}
                          onClick={() => setDailyVolume(dailyVolume - 1)}
                        >
                          <KeyboardArrowDownRoundedIcon
                            sx={{ color: dailyVolume === 1 ? "#C0C0C0" : "" }}
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  {dailyVolStatus && (
                    <div className="upgradeplanforwarmupbox">
                      <div className="insideboxwarmplan">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M10 9.16667V13.3333M10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 14.1421 14.1421 17.5 10 17.5ZM10.0415 6.66667V6.75L9.9585 6.75016V6.66667H10.0415Z"
                            stroke="#FE9526"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div>
                          Your daily warm-up Daily volume increase limit is{" "}
                          {maxLimitProgress}. If you’d like to raise it, please
                        </div>
                        <div
                          onClick={() => {
                            history.push("/Pricing");
                          }}
                          className="upgradeplkanwarm"
                        >
                          Upgrade Plan
                        </div>
                      </div>
                    </div>
                  )}
                  <div
                    style={{
                      display: toggleProgressiveStrategy ? "none" : "block",
                    }}
                  >
                    <div
                      style={{
                        lineHeight: "20px",
                        color: "#4B4B4B",
                        fontFamily: "Source Sans 3",
                        fontSize: "12px",
                        fontWeight: 400,
                        fontStyle: "normal",
                        textAlign:'start'
                      }}
                    >
                      Daily sending goal({maxLimit})
                    </div>
                    <p
                      style={{
                        color: "#727272",
                        fontFamily: "Source Sans 3",
                        fontSize: "11px",
                        fontWeight: 400,
                        fontStyle: "normal",
                        margin: "4px 0px",
                      }}
                    >
                      This is the sending goal of your Progressive warm-up
                      campaign. After reaching this goal, the warm-up campaign
                      wil continue steadily sending this number of email
                      messages every day tll the scheduled end. We recommend to
                      set this goal at 40.
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: "#FAFAFA",
                        borderRadius: "6px",
                        border: "1px solid #1C485F",
                        padding: "0px 8px 0px 12px",
                      }}
                    >
                      <input
                        type="text"
                        value={dailySendingGoalValue}
                        onChange={(e) => {
                          if (e.target.value <= maxLimit) {
                            setDailySendingGoalValue(Number(e.target.value));
                            setMesPerStatus(false);
                          } else {
                            setMesPerStatus(true);
                          }
                        }}
                        style={{
                          color: "#727272",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontWeight: 400,
                          fontStyle: "normal",
                          outline: "none",
                          flexGrow: 1,
                          backgroundColor: "transparent",
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <button
                          disabled={dailySendingGoalValue === maxLimit}
                          style={{ outline: "none" }}
                          onClick={() =>
                            setDailySendingGoalValue(dailySendingGoalValue + 1)
                          }
                        >
                          <KeyboardArrowUpRoundedIcon
                            sx={{
                              color:
                                dailySendingGoalValue === maxLimit
                                  ? "#C0C0C0"
                                  : "",
                            }}
                          />
                        </button>
                        <button
                          disabled={dailySendingGoalValue === starTingVolume}
                          style={{ outline: "none", marginTop: "-12px" }}
                          onClick={() =>
                            setDailySendingGoalValue(dailySendingGoalValue - 1)
                          }
                        >
                          <KeyboardArrowDownRoundedIcon
                            sx={{
                              color:
                                dailySendingGoalValue === starTingVolume
                                  ? "#C0C0C0"
                                  : "",
                            }}
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {mesPerStatus && (
                  <div className="upgradeplanforwarmupbox">
                    <div className="insideboxwarmplan">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M10 9.16667V13.3333M10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 14.1421 14.1421 17.5 10 17.5ZM10.0415 6.66667V6.75L9.9585 6.75016V6.66667H10.0415Z"
                          stroke="#FE9526"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <div>
                        Your daily warm-up Daily sending goal is {maxLimit}. If
                        you’d like to raise it, please
                      </div>
                      <div
                        onClick={() => {
                          history.push("/Pricing");
                        }}
                        className="upgradeplkanwarm"
                      >
                        Upgrade Plan
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {selectedStratergy === "Steady" && (
            <div style={{ cursor: "pointer" }}>
              <div
                style={{
                  // backgroundColor:
                  //   selectedStratergy === "Steady" ? "#D1DFE9" : "#F3F3F3",
                  padding: "12px",
                  display: "flex",
                  gap: "7px",
                  alignItems: "center",
                }}
              >
                <div
                  style={{ display: "flex", gap: "7px", alignItems: "center" }}
                >
                  {selectedStratergy === "Steady" ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M19.25 6.6V17.4C19.25 18.9 18.61 19.5 17.02 19.5H15.98C14.39 19.5 13.75 18.9 13.75 17.4V6.6C13.75 5.1 14.39 4.5 15.98 4.5H17.02C18.61 4.5 19.25 5.1 19.25 6.6Z"
                        stroke="#1C485F"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10.75 8.6V15.4C10.75 16.9 10.11 17.5 8.52 17.5H7.48C5.89 17.5 5.25 16.9 5.25 15.4L5.25 8.6C5.25 7.1 5.89 6.5 7.48 6.5H8.52C10.11 6.5 10.75 7.1 10.75 8.6Z"
                        stroke="#1C485F"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M22 12H19.6"
                        stroke="#1C485F"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13 12H11"
                        stroke="#1C485F"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2 12H4.69"
                        stroke="#1C485F"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M19.25 6.6V17.4C19.25 18.9 18.61 19.5 17.02 19.5H15.98C14.39 19.5 13.75 18.9 13.75 17.4V6.6C13.75 5.1 14.39 4.5 15.98 4.5H17.02C18.61 4.5 19.25 5.1 19.25 6.6Z"
                        stroke="#393939"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10.75 8.6V15.4C10.75 16.9 10.11 17.5 8.52 17.5H7.48C5.89 17.5 5.25 16.9 5.25 15.4L5.25 8.6C5.25 7.1 5.89 6.5 7.48 6.5H8.52C10.11 6.5 10.75 7.1 10.75 8.6Z"
                        stroke="#393939"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M22 12H19.6"
                        stroke="#393939"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13 12H11"
                        stroke="#393939"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2 12H4.69"
                        stroke="#393939"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  )}

                  <p
                    style={{
                      color:
                        selectedStratergy === "Steady" ? "#1C485F" : "#393939",
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontWeight: 400,
                      fontStyle: "normal",
                    }}
                  >
                    Steady
                  </p>
                </div>
                <p
                  style={{
                    color: "#727272",
                    fontFamily: "Source Sans 3",
                    fontSize: "11px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  For improving existing deliverability problems that land your
                  emails in Spam or Promotions.
                </p>
              </div>
              <div
                style={{
                  padding: "12px",
                  border: "1px solid #DDD",
                  borderRadius: "0px 0px 4px 4px",
                }}
              >
                <div
                  style={{
                    lineHeight: "20px",
                    color: "#4B4B4B",
                    fontFamily: "Source Sans 3",
                    fontSize: "12px",
                    fontWeight: 400,
                    fontStyle: "normal",
                    textAlign: "start",
                  }}
                >
                  Message per day({maxLimit})
                </div>
                <p
                  style={{
                    color: "#727272",
                    fontFamily: "Source Sans 3",
                    fontSize: "11px",
                    fontWeight: 400,
                    fontStyle: "normal",
                    margin: "4px 0px",
                  }}
                >
                  The number of email that will be sent everyday for this
                  warm-up campaign.We recommend to set this limit at 40
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: "#FAFAFA",
                    borderRadius: "6px",
                    border: "1px solid #C0C0C0",
                    padding: "0px 8px 0px 12px",
                  }}
                >
                  <input
                    type="text"
                    value={messagesPerDay}
                    onChange={(e) => {
                      if (e.target.value <= maxLimit) {
                        setMessagesPerDay(Number(e.target.value));
                        setMesPerStatus(false);
                      } else {
                        setMesPerStatus(true);
                      }
                    }}
                    style={{
                      color: "#727272",
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontWeight: 400,
                      fontStyle: "normal",
                      outline: "none",
                      flexGrow: 1,
                      backgroundColor: "transparent",
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <button
                      disabled={messagesPerDay === maxLimit}
                      onClick={() => setMessagesPerDay(messagesPerDay + 1)}
                      style={{ outline: "none" }}
                    >
                      <KeyboardArrowUpRoundedIcon
                        sx={{
                          color: messagesPerDay === maxLimit ? "#C0C0C0" : "",
                        }}
                      />
                    </button>
                    <button
                      disabled={messagesPerDay === 1}
                      onClick={() => setMessagesPerDay(messagesPerDay - 1)}
                      style={{ outline: "none", marginTop: "-12px" }}
                    >
                      <KeyboardArrowDownRoundedIcon
                        sx={{ color: messagesPerDay === 1 ? "#C0C0C0" : "" }}
                      />
                    </button>
                  </div>
                </div>
                {mesPerStatus && (
                  <div className="upgradeplanforwarmupbox">
                    <div className="insideboxwarmplan">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M10 9.16667V13.3333M10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 14.1421 14.1421 17.5 10 17.5ZM10.0415 6.66667V6.75L9.9585 6.75016V6.66667H10.0415Z"
                          stroke="#FE9526"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <div>
                        Your daily warm-up sending limit is {maxLimit}. If you’d
                        like to raise it, please
                      </div>
                      <div
                        onClick={() => {
                          history.push("/Pricing");
                        }}
                        className="upgradeplkanwarm"
                      >
                        Upgrade Plan
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          <div style={{ padding: "0px 12px 20px 12px", height: "220px" }}>
            {console.log("dmdmdmmdmdd", dataSteady)}
            {selectedStratergy === "Steady" ? (
              <Bar options={optionsSteady} data={dataSteady} />
            ) : (
              <Bar options={options} data={data} />
            )}
          </div>
          {/* <div>
                        <div style={{ backgroundColor: "#F3F3F3", padding: "12px", display: "flex", gap: "7px", alignItems: "center" }}>
                            <div style={{ display: "flex", gap: "7px", alignItems: "center" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M19.9 13.5L4.1 13.5C2.6 13.5 2 14.14 2 15.73L2 19.77C2 21.36 2.6 22 4.1 22H19.9C21.4 22 22 21.36 22 19.77V15.73C22 14.14 21.4 13.5 19.9 13.5Z" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.9 2H4.1C2.6 2 2 2.64 2 4.23L2 8.27C2 9.86 2.6 10.5 4.1 10.5H10.9C12.4 10.5 13 9.86 13 8.27V4.23C13 2.64 12.4 2 10.9 2Z" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.9 2H18.1C16.6 2 16 2.64 16 4.23V8.27C16 9.86 16.6 10.5 18.1 10.5H19.9C21.4 10.5 22 9.86 22 8.27V4.23C22 2.64 21.4 2 19.9 2Z" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p style={{ color: "#393939", fontFamily: "Source Sans 3", fontSize: "14px", fontWeight: 400, fontStyle: "normal" }}>Custom (Advanced)</p>
                            </div>
                            <p style={{ color: "#727272", fontFamily: "Source Sans 3", fontSize: "11px", fontWeight: 400, fontStyle: "normal", }}>Build your own warm-up campaign strategy.
                            </p>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #DDD", borderRadius: "0px 0px 4px 4px", padding: "12px", backgroundColor: "#FAFAFA" }}>
                            <Button sx={{ textTransform: "none", padding: "16px", color: "#868686", border: "1px solid #DDD", outline: "none", "&:hover": { backgroundColor: "transparent" } }} disableRipple disableElevation >
                                Coming Soon
                            </Button>
                        </div>
                    </div> */}
        </div>
      </div>
    );
  };

  function generateAnother() {
    const randomIndex = Math.floor(Math.random() * staticEmails.length);
    setEmailBody(staticEmails[randomIndex].body);
    setSubject(staticEmails[randomIndex].subject);
  }
  const thirdStepContent = () => {
    return (
      <div style={{ backgroundColor: "#fff" }}>
        <div
          style={{
            padding: "12px",
            backgroundColor: "#fff",
            borderBottom: "1px solid #DDD",
          }}
        >
          <p
            style={{
              color: "#393939",
              fontSize: "15px",
              fontWeight: 700,
              fontFamily: "Source Sans 3",
            }}
          >
            Pick your message content type
          </p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "14px",
            // padding: "12px",
          }}
        >
          <div>
            <div
              style={{
                // backgroundColor: "#D1DFE9",
                padding: "12px 12px 0px 12px",
                display: "flex",
                gap: "7px",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{ display: "flex", gap: "7px", alignItems: "center" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19.06 18.6703L16.92 14.4004L14.78 18.6703"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15.1699 17.9102H18.6899"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.9201 21.9998C14.1201 21.9998 11.8401 19.7298 11.8401 16.9198C11.8401 14.1198 14.1101 11.8398 16.9201 11.8398C19.7201 11.8398 22.0001 14.1098 22.0001 16.9198C22.0001 19.7298 19.7301 21.9998 16.9201 21.9998Z"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.02 2H8.94C11.01 2 12.01 3.00002 11.96 5.02002V8.94C12.01 11.01 11.01 12.01 8.94 11.96H5.02C3 12 2 11 2 8.92999V5.01001C2 3.00001 3 2 5.02 2Z"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.00995 5.84961H4.94995"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6.96997 5.16992V5.84991"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.98994 5.83984C7.98994 7.58984 6.61994 9.00983 4.93994 9.00983"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.0099 9.01001C8.2799 9.01001 7.61991 8.62 7.15991 8"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2 15C2 18.87 5.13 22 9 22L7.95 20.25"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M22 9C22 5.13 18.87 2 15 2L16.05 3.75"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p
                  style={{
                    color: "#1C485F",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  Al-Powered
                </p>
                <p
                  style={{
                    color: "#727272",
                    fontFamily: "Source Sans 3",
                    fontSize: "11px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  Each email will contain unique algorithm-generated text
                </p>
              </div>

              <div>
                <div
                  className="valueinsidethecontent"
                  style={{
                    textAlign: "center",
                    color: "#1c485f",
                    cursor: "pointer",
                    fontWeight: 600,
                    padding: "6px 10px",
                    backgroundColor: "#d1dfe9",
                    borderRadius: "4px",
                  }}
                  onClick={() => {
                    generateAnother();
                  }}
                >
                  Generate another Email
                </div>
              </div>
            </div>

            {/* <div style={{ display: "flex", flexDirection: "column", gap: "12px", border: "1px solid #DDD", borderRadius: "0px 0px 4px 4px", padding: "12px" }}>
                            <div>
                                <div style={{ lineHeight: "20px", color: "#4B4B4B", fontFamily: "Source Sans 3", fontSize: "12px", fontWeight: 400, fontStyle: "normal" }}>Message per day</div>
                                <p style={{ color: "#727272", fontFamily: "Source Sans 3", fontSize: "11px", fontWeight: 400, fontStyle: "normal", margin: "4px 0px" }}>The number of email that will be sent everyday for this warm-up campaign.We recommend to set this limit at 40</p>
                                <input type="number" style={{ padding: "12px 8px", backgroundColor: "#FAFAFA", borderRadius: "6px", width: "100%", outline: "none" }} />
                            </div>
                        </div> */}
          </div>
          {/* <div>
                        <div style={{ backgroundColor: "#F3F3F3", padding: "12px", display: "flex", gap: "7px", alignItems: "center" }}>
                            <div style={{ display: "flex", gap: "7px", alignItems: "center" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M19.9 13.5L4.1 13.5C2.6 13.5 2 14.14 2 15.73L2 19.77C2 21.36 2.6 22 4.1 22H19.9C21.4 22 22 21.36 22 19.77V15.73C22 14.14 21.4 13.5 19.9 13.5Z" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.9 2H4.1C2.6 2 2 2.64 2 4.23L2 8.27C2 9.86 2.6 10.5 4.1 10.5H10.9C12.4 10.5 13 9.86 13 8.27V4.23C13 2.64 12.4 2 10.9 2Z" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.9 2H18.1C16.6 2 16 2.64 16 4.23V8.27C16 9.86 16.6 10.5 18.1 10.5H19.9C21.4 10.5 22 9.86 22 8.27V4.23C22 2.64 21.4 2 19.9 2Z" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p style={{ color: "#393939", fontFamily: "Source Sans 3", fontSize: "14px", fontWeight: 400, fontStyle: "normal" }}>Mixed</p>
                            </div>
                            <p style={{ color: "#727272", fontFamily: "Source Sans 3", fontSize: "11px", fontWeight: 400, fontStyle: "normal", }}>Combine both strategies for all-round deliverability improvement.
                            </p>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #DDD", borderRadius: "0px 0px 4px 4px", padding: "12px", backgroundColor: "#FAFAFA" }}>
                            <Button sx={{ textTransform: "none", padding: "16px", color: "#868686", border: "1px solid #DDD", outline: "none", "&:hover": { backgroundColor: "transparent" } }} disableRipple disableElevation >
                                Coming Soon
                            </Button>
                        </div>
                    </div> */}
        </div>
        <div
          style={{ padding: "12px" }}
          // className="subjectandbodywarmup"
          // style={{ width: "80vw", height: "100%" }}
        >
          <WarmUpClass
            setEmailBody={setEmailBody}
            emailBody={emailBody}
            subject={subject}
            setSubject={setSubject}
          />
        </div>
      </div>
    );
  };

  const fourthStepContent = () => {
    return (
      <div style={{ backgroundColor: "#fff" }}>
        <div
          style={{
            padding: "12px",
            backgroundColor: "#fff",
            borderBottom: "1px solid #DDD",
          }}
        >
          <p
            style={{
              color: "#393939",
              fontSize: "15px",
              fontWeight: 700,
              fontFamily: "Source Sans 3",
            }}
          >
            Warm-up campaign review
          </p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            padding: "12px",
          }}
        >
          <div
            style={{
              padding: "12px",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              borderRadius: "6px",
            }}
          >
            {/* <div
              style={{
                padding: "12px 8px",
                backgroundColor: "#D1DFE9",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p
                style={{
                  color: "#1C485F",
                  fontSize: "15px",
                  fontWeight: 400,
                  fontFamily: "Source Sans 3",
                }}
              >
                Warm-up settings
              </p>
              <button>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.0399 3.01928L8.15988 10.8993C7.85988 11.1993 7.55988 11.7893 7.49988 12.2193L7.06988 15.2293C6.90988 16.3193 7.67988 17.0793 8.76988 16.9293L11.7799 16.4993C12.1999 16.4393 12.7899 16.1393 13.0999 15.8393L20.9799 7.95928C22.3399 6.59928 22.9799 5.01928 20.9799 3.01928C18.9799 1.01928 17.3999 1.65928 16.0399 3.01928Z"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.9102 4.15039C15.5802 6.54039 17.4502 8.41039 19.8502 9.09039"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div> */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              <label htmlFor="mail">Mailbox</label>
              <input
                readOnly
                type="text"
                id="mail"
                style={{
                  padding: "8px",
                  backgroundColor: "#FAFAFA",
                  border: "1px solid #1C485F",
                  borderRadius: "4px",
                  outline: "none",
                }}
                value={accountList}
              />
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              <div>
                <div
                  style={{
                    lineHeight: "20px",
                    color: "#393939",
                    fontSize: "12px",
                    fontWeight: 400,
                    fontFamily: "Source Sans 3",
                    textAlign:'start'
                  }}
                >
                  Reply rate, %
                </div>
                <p
                  style={{
                    color: "#393939",
                    fontSize: "10.5px",
                    fontWeight: 400,
                    fontFamily: "Source Sans 3",
                  }}
                >
                  You can set a custom reply rate for your warm-up campaign. We
                  recommend to keep it at around 30% (meaning 30% of your email
                  messages will receive replies). A higher reply rate may look
                  suspicious to the spam filters.
                </p>
              </div>
              <input
                readOnly
                type="number"
                style={{
                  padding: "8px",
                  backgroundColor: "#FAFAFA",
                  borderRadius: "4px",
                  outline: "none",
                  border: "1px solid #1C485F",
                }}
                value={defaultReplyRateLimit}
              />
            </div>
            {/* <div
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              <div>
                <div
                  style={{
                    lineHeight: "20px",
                    color: "#393939",
                    fontSize: "12px",
                    fontWeight: 400,
                    fontFamily: "Source Sans 3",
                  }}
                >
                  Campaign deadline
                </div>
                <p
                  style={{
                    color: "#393939",
                    fontSize: "10.5px",
                    fontWeight: 400,
                    fontFamily: "Source Sans 3",
                  }}
                >
                  Your warm-up campaign will start immediately after launch and
                  end on the chosen date. The longer the warm-up campaign, the
                  better results it will yield. We recommend no less than 30
                  days.
                </p>
              </div>
              <input readOnly type='number' style={{ padding: "8px", backgroundColor: "#FAFAFA", borderRadius: "4px" }} value={dateForLastStep} />
              <p
                style={{
                  padding: "8px",
                  backgroundColor: "#FAFAFA",
                  borderRadius: "4px",
                  border: "1px solid #1C485F",
                }}
              >
                {dateForLastStep}
              </p>
            </div> */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            >
              <h1
                style={{
                  lineHeight: "20px",
                  fontFamily: "Source Sans 3",
                  color: "#4B4B4B",
                  fontSize: "14px",
                  fontWeight: 700,
                  fontStyle: "normal",
                }}
              >
                Schedule
              </h1>
              <div
                className="scheduleboxdrawer"
                style={{ backgroundColor: "#D1DFE9", border: "1px solid #DDD" }}
              >
                <div className="shcedulelistbox">
                  {" "}
                  <div style={{ display: "flex" }}>{selectedSchedule.Name}</div>
                  <div className="shcedulerightsideicom"></div>
                </div>
                <div
                  className="shedulednametext"
                  style={{ border: "1px solid #1C485F" }}
                >
                  {selectedSchedule.TimeZone}
                </div>
                <div className="weeknameslist">
                  {selectedSchedule &&
                    selectedSchedule.Day.map((value) => {
                      return (
                        <div className="nameandticked">
                          {" "}
                          {!value.Active ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="23"
                              height="23"
                              viewBox="0 0 24 25"
                              fill="none"
                            >
                              <rect
                                x="0.5"
                                y="1.46069"
                                width="23"
                                height="23"
                                rx="3.5"
                                fill="white"
                                stroke="#1C485F"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="23"
                              height="23"
                              viewBox="0 0 25 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="0.25"
                                width="24"
                                height="24"
                                rx="4"
                                fill="#1C485F"
                              />
                              <path
                                d="M19.1069 6.85693L9.67829 16.2855L5.39258 11.9998"
                                stroke="white"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          )}{" "}
                          {value.Day}
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              borderRadius: "6px",
            }}
          >
            <div
              style={{
                padding: "12px 8px",

                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                margin: "0px 12px",
              }}
            >
              <p
                style={{
                  color: "#1C485F",
                  fontSize: "15px",
                  fontWeight: 400,
                  fontFamily: "Source Sans 3",
                }}
              >
                {selectedStratergy === "Steady"
                  ? "Steady Strategy"
                  : "Progressive Strategy"}
              </p>
              {/* <button
                onClick={() => history.push(`/MailWarmUp?step=${2}`)}
                style={{ outline: "none" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.0399 3.01928L8.15988 10.8993C7.85988 11.1993 7.55988 11.7893 7.49988 12.2193L7.06988 15.2293C6.90988 16.3193 7.67988 17.0793 8.76988 16.9293L11.7799 16.4993C12.1999 16.4393 12.7899 16.1393 13.0999 15.8393L20.9799 7.95928C22.3399 6.59928 22.9799 5.01928 20.9799 3.01928C18.9799 1.01928 17.3999 1.65928 16.0399 3.01928Z"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.9102 4.15039C15.5802 6.54039 17.4502 8.41039 19.8502 9.09039"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button> */}
            </div>
            <div style={{ padding: "0px 12px 20px 12px", height: "220px" }}>
              {selectedStratergy === "Steady" ? (
                <Bar options={optionsSteady} data={dataSteady} />
              ) : (
                <Bar options={options} data={data} />
              )}
            </div>
          </div>
          <div>
            {/* <div
              style={{
                padding: "12px 8px",
                backgroundColor: "#D1DFE9",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p
                style={{
                  color: "#1C485F",
                  fontSize: "15px",
                  fontWeight: 400,
                  fontFamily: "Source Sans 3",
                }}
              >
                Email Content
              </p>
              <button>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.0399 3.01928L8.15988 10.8993C7.85988 11.1993 7.55988 11.7893 7.49988 12.2193L7.06988 15.2293C6.90988 16.3193 7.67988 17.0793 8.76988 16.9293L11.7799 16.4993C12.1999 16.4393 12.7899 16.1393 13.0999 15.8393L20.9799 7.95928C22.3399 6.59928 22.9799 5.01928 20.9799 3.01928C18.9799 1.01928 17.3999 1.65928 16.0399 3.01928Z"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.9102 4.15039C15.5802 6.54039 17.4502 8.41039 19.8502 9.09039"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div> */}
            {/* <div>
              <h1
                style={{
                  lineHeight: "20px",
                  color: "#4B4B4B",
                  fontSize: "14px",
                  fontWeight: 400,
                  fontFamily: "Source Sans 3",
                  padding: "12px 4px",
                }}
              >
                Al-Powered
              </h1>
              <div
                style={{
                  padding: "20px 6px",
                  border: "1px solid #DDD",
                  borderRadius: "6px",
                }}
              >
                <p
                  style={{
                    color: "#727272",
                    fontSize: "12px",
                    fontWeight: 400,
                    fontFamily: "Source Sans 3",
                  }}
                >
                  Using a complex language model our Al algorithm creates
                  lifelike messages for both warm-up emails and replies.This
                  makes it impossible for email providers to tell your warm-up
                  campaign from a real dialogue, so your email reputation and
                  deliverability grow as naturally as possible
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
  };

  const renderDifferentStepsContent = () => {
    switch (Number(activeStep)) {
      case 1:
        return firstStepContent();
      case 2:
        return secondStepContent();
      case 3:
        return thirdStepContent();
      case 4:
        return fourthStepContent();
      default:
        return null;
    }
  };

  const [openEmailEmailInstructionModal, setOpenEmailEmailInstructionModal] =
    useState(false);
  const [openEmailAccountDrawer, setOpenEmailAccountDrawer] = useState(false);
  const [openScheduleDrawer, setOpenScheduleDrawer] = useState(false);

  const catchPropsData = (data) => {
    setShowToaster(true);
    if (data.status) {
      getAllSendEmails();
      toast.success(data.message, {
        autoClose: true,
        position: "top-right",
        duration: 3000,
      });
      setOpenEmailAccountDrawer(false);
    } else {
      getAllSendEmails();
      toast.error(data.message, {
        autoClose: true,
        position: "top-right",
        duration: 3000,
      });
      setOpenEmailAccountDrawer(true);
    }
  };

  return (
    <>
      {openScheduleDrawer && (
        <CreateScheduleDrawer
          openCreateScheduleDrawer={openScheduleDrawer}
          setterFun={setOpenScheduleDrawer}
          selectedScheduleData={selectedSchedule}
          selectedScheduleSetterFun={setSelectedSchedule}
        />
      )}
      {activeStep === null ? (
        <div
          style={{
            height: "100%",
            overflow: "auto",
            padding: "12px",
            borderRadius: "5px",
            backgroundColor: "transparent",
          }}
        >
          <div
            style={{
              borderRadius: "6px",
              backgroundColor: "#fff",
              padding: "0px 10px 10px 10px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                borderTopRightRadius: "6px",
                borderTopLeftRadius: "6px",
              }}
              className="allcampairnlistandfilters"
            >
              <div className="allcomponantcampaign">All Warm-Ups</div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="seacrhsyboldesign">
                  <CustomeSurendra />
                </div>
                <div
                  ref={anchorRef3}
                  style={{
                    padding: "11px 14px",
                    border: "1px solid #1C485F",
                    display: "flex",
                    gap: "6px",
                    alignItems: "center",
                    borderRadius: "4px",
                  }}
                  onClick={() => {
                    setOpenDropdown2(true);
                  }}
                >
                  <p
                    style={{
                      color: "#868686",
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                    }}
                  >
                    Filter by status
                  </p>
                </div>
                <div
                  onClick={() => {
                    console.log("path", `/MailWarmUp?step=${1}`);
                    history.push(`/MailWarmUp?step=${1}`);
                  }}
                  style={{ marginLeft: "12px", letterSpacing: "0.8px" }}
                  className="createCampaignfilledbutton"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_2010_4013)">
                      <path
                        d="M8 16H5.43C3.14 16 2 14.86 2 12.57V5.43C2 3.14 3.14 2 5.43 2H10C12.29 2 13.43 3.14 13.43 5.43"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M18.5701 22H14.0001C11.7101 22 10.5701 20.86 10.5701 18.57V11.43C10.5701 9.14 11.7101 8 14.0001 8H18.5701C20.8601 8 22.0001 9.14 22.0001 11.43V18.57C22.0001 20.86 20.8601 22 18.5701 22Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14.8701 15H18.1301"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16.5 16.63V13.37"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2010_4013">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  Create Warm-up
                </div>
              </div>
            </div>
            <Popper
              open={openDropdown2}
              anchorEl={anchorRef3.current}
              role={undefined}
              placement="bottom-start"
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom-start" ? "left top" : "left bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener
                      onClickAway={() => {
                        setOpenDropdown2(false);
                      }}
                    >
                      <MenuList
                        style={{ width: "13.5vw" }}
                        autoFocusItem={openDropdown2}
                        id="composition-menu"
                        aria-labelledby="composition-button"
                      >
                        {dropdownItemsFilter.map((val, idx) => {
                          return (
                            <MenuItem
                              onClick={() => {
                                if (selectedFilter.includes(val.name)) {
                                  selectedFilter.map((value, index) => {
                                    if (value === val.name) {
                                      selectedFilter.splice(index, 1);
                                      setSelectedFilter([...selectedFilter]);
                                    }
                                  });
                                } else {
                                  setSelectedFilter([
                                    ...selectedFilter,
                                    val.name,
                                  ]);
                                }

                                // setOpenDropdown2(false);
                              }}
                              className="itemsinsidethedropdown"
                              style={{
                                background:
                                  dropItem === idx
                                    ? "var(--color-dark-50, #F3F3F3)"
                                    : "var(--color-white, #FFF)",
                                padding: " 10px 16px",
                                color: "var(--color-dark-500, #868686)",
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "20px",
                              }}
                            >
                              <Checkbox
                                checked={selectedFilter.includes(val.name)}
                                size="small"
                                style={{ color: "#1C485F", padding: 0 }}
                              />
                              {val.svg}
                              {val.name}
                            </MenuItem>
                          );
                        })}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(9,1fr)",
                gap: "14px",
                padding: "14px 8px",
                backgroundColor: "#FAFAFA",
                borderRadius: "12px",
                marginTop: "6px",
              }}
            >
              <div
                style={{
                  gridColumn: "span 2",
                  color: "#393939",
                  fontSize: "14px",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontFamily: "Source Sans 3",
                  letterSpacing: "0.8px",
                }}
              >
                Mailbox
              </div>
              <div
                style={{
                  gridColumn: "span 1",
                  color: "#393939",
                  fontSize: "14px",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontFamily: "Source Sans 3",
                  letterSpacing: "0.8px",
                }}
              >
                Status
              </div>
              <div
                style={{
                  gridColumn: "span 1",
                  color: "#393939",
                  fontSize: "14px",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontFamily: "Source Sans 3",
                  letterSpacing: "0.8px",
                }}
              >
                Strategy
              </div>
              <div
                style={{
                  gridColumn: "span 1",
                  color: "#393939",
                  fontSize: "14px",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontFamily: "Source Sans 3",
                  letterSpacing: "0.8px",
                }}
              >
                Sent today
              </div>
              <div
                style={{
                  gridColumn: "span 1",
                  color: "#393939",
                  fontSize: "14px",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontFamily: "Source Sans 3",
                  letterSpacing: "0.8px",
                }}
              >
                Reply rate
              </div>
              <div
                style={{
                  gridColumn: "span 1",
                  color: "#393939",
                  fontSize: "14px",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontFamily: "Source Sans 3",
                  letterSpacing: "0.8px",
                }}
              >
                Start date
              </div>
              <div
                style={{
                  gridColumn: "span 1",
                  color: "#393939",
                  fontSize: "14px",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontFamily: "Source Sans 3",
                  letterSpacing: "0.8px",
                }}
              >
                End date
              </div>
              <div
                style={{
                  gridColumn: "span 1",
                  color: "#393939",
                  fontSize: "14px",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontFamily: "Source Sans 3",
                  letterSpacing: "0.8px",
                }}
              >
                Deliveribility
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "16px 0px",
              }}
            >
              <img src={nowarmupImage} alt="no-warmup" loading="eager" />
              <p
                style={{
                  color: "#727272",
                  fontSize: "15px",
                  fontWeight: 400,
                  fontFamily: "Source Sans 3",
                  maxWidth: "650px",
                  textAlign: "center",
                }}
              >
                Warm up your mailbox to improve deliverability, grow sender
                reputation and prepare new email accounts for campaigns.
              </p>
              <button
                onClick={() => history.push(`/MailWarmUp?step=${1}`)}
                className="bg-primary"
                style={{
                  display: "flex",
                  gap: 4,
                  alignItems: "center",
                  fontFamily: "Source Sans 3",
                  color: "#fff",
                  fontSize: "13px",
                  fontStyle: "normal",
                  padding: "7px 14px",
                  borderRadius: "4px",
                  outline: "none",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                >
                  <path
                    d="M7.16602 10H13.8327"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.5 13.3327V6.66602"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.99935 18.3327H12.9993C17.166 18.3327 18.8327 16.666 18.8327 12.4993V7.49935C18.8327 3.33268 17.166 1.66602 12.9993 1.66602H7.99935C3.83268 1.66602 2.16602 3.33268 2.16602 7.49935V12.4993C2.16602 16.666 3.83268 18.3327 7.99935 18.3327Z"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Create warm-up
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            height: "100%",
            position: "relative",
          }}
        >
          <div
            style={{
              height: "calc(100% - 50px)",
              margin: "0px 12px 0px 12px",
              padding: "12px 0px",
            }}
          >
            <div
              style={{
                padding: "7px",
                backgroundColor: "#fff",
                borderRadius: "6px",
                borderBottom: "1px solid #DDD",
                height: "40px",
              }}
            >
              <button
                style={{
                  cursor: "default",
                  outline: "none",
                  borderBottom: "2px solid #1C485F",
                  borderRadius: 0,
                  color: "#1C485F",
                  padding: "4px 8px",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                <p
                  style={{
                    color: "#1C485F",
                    fontSize: "15px",
                    fontWeight: 700,
                    fontFamily: "Source Sans 3",
                  }}
                >
                  All Warm-Ups
                </p>
              </button>
            </div>
            <div
              style={{
                backgroundColor: "#FFF",
                height: "calc(100% - 58px)",
                overflow: "auto",
                marginTop: "12px",
                border: "1px solid #DDD",
                display: "flex",
                padding: "10px",
                borderRadius: "5px",
              }}
            >
              <div
                style={
                  {
                    // backgroundColor:'red',
                  }
                }
              >
                <nav style={{ minWidth: "120px" }}>
                  <ol>
                    {steps.map((step) => (
                      <>
                        <li
                          key={step.name}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "4px 10px",
                                border:
                                  Number(activeStep) === step.id
                                    ? "2px solid #1C485F"
                                    : Number(activeStep) > step.id
                                    ? "2px solid #1C485F"
                                    : "2px solid #DDDDDD",
                                borderRadius: "100%",
                                backgroundColor:
                                  Number(activeStep) === step.id
                                    ? "#fff"
                                    : Number(activeStep) > step.id
                                    ? "#1C485F"
                                    : "#DDD",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "12px",
                                  color:
                                    Number(activeStep) === step.id
                                      ? "#4B4B4B"
                                      : Number(activeStep) > step.id
                                      ? "#fff"
                                      : "#4B4B4B",
                                  fontFamily: "Source Sans 3",
                                  fontWeight: 700,
                                  fontStyle: "normal",
                                }}
                              >
                                {step.id}
                              </span>
                            </div>
                            <span
                              style={{
                                fontSize: "12px",
                                color: "#4B4B4B",
                                fontFamily: "Source Sans 3",
                                fontWeight: 700,
                                fontStyle: "normal",
                              }}
                            >
                              {step.name}
                            </span>
                          </div>
                          {step.id !== steps.length && (
                            <div
                              style={{
                                height: "9vh",
                                width: "3px",
                                backgroundColor:
                                  Number(activeStep) === step.id
                                    ? "#DDD"
                                    : Number(activeStep) > step.id
                                    ? "#1C485F"
                                    : "#DDD",
                              }}
                            ></div>
                          )}
                        </li>
                      </>
                    ))}
                  </ol>
                </nav>
              </div>
              <div
                style={{
                  flexGrow: 1,
                  border: "1px solid #DDD",
                  borderRadius: "4px",
                  backgroundColor: "#FFF",
                  // height: "69vh",
                  overflowY: "scroll",
                }}
              >
                {renderDifferentStepsContent()}
              </div>
            </div>
          </div>
          {activeStep !== null && (
            <div
              style={{
                padding: "7px 14px",
                backgroundColor: "#fff",
                display: "flex",
                gap: "12px",
                justifyContent: "space-between",
                borderTop: "1px solid #DDD",
                // flexShrink:0,
                height: "50px",
                //zIndex: 300,
              }}
            >
              <button
                onClick={() => {
                  history.goBack();
                }}
                style={{
                  backgroundColor: "#fff",
                  fontFamily: "Source Sans 3",
                  color: "#1C485F",
                  fontSize: "13px",
                  fontStyle: "normal",
                  padding: "7px 14px",
                  borderRadius: "4px",
                  outline: "none",
                  border: "1px solid #1C485F",
                }}
              >
                Cancel
              </button>
              <div
                style={{ display: "flex", gap: "12px", alignItems: "center" }}
              >
                <button
                  onClick={() => {
                    if (Number(activeStep) > 1) {
                      history.push(
                        `/MailWarmUp?step=${Number(activeStep) - 1}`
                      );
                    }
                  }}
                  style={{
                    display: Number(activeStep) === 1 ? "none" : "block",
                    backgroundColor: "#fff",
                    fontFamily: "Source Sans 3",
                    color: "#1C485F",
                    fontSize: "13px",
                    fontStyle: "normal",
                    padding: "7px 18px",
                    borderRadius: "4px",
                    outline: "none",
                    border: "1px solid #1C485F",
                  }}
                >
                  Back
                </button>
                {console.log("active step", activeStep)}
                {loader && Number(activeStep) === 4 ? (
                  <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
                    <CircularProgress size={20} sx={{ color: "#1C485F" }} />
                  </div>
                ) : (
                  <button
                    onClick={() => {
                      if (Number(activeStep) < 4) {
                        history.push(
                          `/MailWarmUp?step=${Number(activeStep) + 1}`
                        );
                      } else {
                        createEmailWarmUp();
                      }
                    }}
                    style={{
                      pointerEvents:
                        ((Number(activeStep) === 1 &&
                          (!accountList ||
                            !selectedSchedule ||
                            warmUplimStatus)) ||
                          (Number(activeStep) === 2 && !selectedStratergy)) &&
                        "none",
                      fontFamily: "Source Sans 3",
                      color: "#fff",
                      fontSize: "13px",
                      fontStyle: "normal",
                      padding: "7px 18px",
                      borderRadius: "4px",
                      outline: "none",
                      border: "1px solid transparent",
                    }}
                    className="bg-primary"
                  >
                    Next
                  </button>
                )}
              </div>
            </div>
          )}
          {(openEmailEmailInstructionModal || openEmailAccountDrawer) && (
            <EmailAccountsCopy
              statusObj={catchPropsData}
              openInstructionModal={openEmailEmailInstructionModal}
              openEmailAccountDrawer={openEmailAccountDrawer}
              setOpenEmailAccountDrawer={setOpenEmailAccountDrawer}
              setterFunForEmailInstructionModal={
                setOpenEmailEmailInstructionModal
              }
            />
          )}
          <ToastContainer />
        </div>
      )}
    </>
  );
};

export default EmailWarmUpCopy;
